import { ApolloClient, InMemoryCache } from "@apollo/client"
import * as msalBrowser from "@azure/msal-browser"

const baseUrl = process.env.NEXT_PUBLIC_WS_EXT_APP_BASE_URL
const apiSuffix = process.env.NEXT_PUBLIC_EXT_APP_GQL_API_SUFFIX

const sharedDefaultOptions = {
  fetchPolicy: "no-cache" as const,
}

export const initApollo = (): ApolloClient<unknown> =>
  new ApolloClient({
    cache: new InMemoryCache(),
    defaultOptions: {
      mutate: sharedDefaultOptions,
      query: sharedDefaultOptions,
      watchQuery: sharedDefaultOptions,
    },
    uri: baseUrl + apiSuffix,
  })

export interface ApolloContext {
  context: {
    headers: {
      authorization: string
    }
  }
}

export const createApolloContext = (
  auth: msalBrowser.AuthenticationResult,
): ApolloContext => ({
  context: {
    headers: {
      authorization: auth.accessToken,
    },
  },
})
